import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs md:text-sm">
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {index > 0 && (
            <span className="flex h-3 w-3 items-center justify-center text-foreground-400">
              <i className="ri-arrow-right-s-line"></i>
            </span>
          )}
          {item.to ? (
            <Link
              to={item.to}
              className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-600"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}